import React from 'react';
import AppPaths from '../../AppPaths';
import { Redirect, useLocation } from 'react-router-dom';
import useHardwareFirstShop from '../../hooks/useHardwareFirstShop';

/** The shop root. Redirects straight to the pick-your-fi shop when it is enabled, else the classic listing. */
export default function Home() {
  const location = useLocation();
  const shopEnabled = useHardwareFirstShop();

  return (
    <Redirect to={{ pathname: shopEnabled ? AppPaths.Shop : AppPaths.ProductListingPage, search: location.search }} />
  );
}
